import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	label: {
		id: 'search-page-relay.filters.product-filters.slack-channel.label',
		defaultMessage: 'Channel',
		description: 'Label for the Slack channel filter dropdown',
	},
	placeholder: {
		id: 'search-page-relay.filters.product-filters.slack-channel.placeholder',
		defaultMessage: 'Filter by channel',
		description: 'Placeholder text for the Slack channel filter search input',
	},
	selectedLabel: {
		id: 'search-page-relay.filters.product-filters.slack-channel.selected-label',
		defaultMessage: 'Selected',
		description: 'Group label for selected channels in the dropdown',
	},
	suggestedLabel: {
		id: 'search-page-relay.filters.product-filters.slack-channel.suggested-label',
		defaultMessage: 'Channels',
		description: 'Group label for suggested channels in the dropdown',
	},
});
